import { createContext } from 'react'

export interface ReportSidebarContextValue {
  isOpen: boolean
  /** Node IDs selected for export. null = show all nodes (no filter). */
  selectedNodeIds: Set<string> | null
  open: (selectedNodeIds?: Set<string>) => void
  close: () => void
  toggle: () => void
  /** Re-enter branch selection mode with current selection pre-loaded */
  changeSelection: () => void
}

export const ReportSidebarContext = createContext<ReportSidebarContextValue | null>(null)
